/* La Belle Margaux — collectiepagina: filters, sortering en paginering zonder herladen */
(function () {
  if (window.__lbmcInit) return;
  window.__lbmcInit = true;

  var DESK = window.matchMedia('(min-width: 990px)');
  var ctrl = null;
  var lastOpener = null;

  function root() { return document.querySelector('[data-lbmc-root]'); }
  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function lock(on) { document.documentElement.classList.toggle('lbmc-lock', on); }

  function closeGroups(except) {
    var r = root(); if (!r) return;
    qa('[data-lbmc-gbtn][aria-expanded="true"]', r).forEach(function (b) { if (b !== except) b.setAttribute('aria-expanded', 'false'); });
  }
  function closeSort() {
    var r = root(); if (!r) return;
    var s = q('[data-lbmc-sort]', r); if (!s) return;
    s.classList.remove('is-open');
    var b = q('[data-lbmc-sort-btn]', r); if (b) b.setAttribute('aria-expanded', 'false');
  }
  function openDrawer(opener) {
    var r = root(); var d = r && q('[data-lbmc-drawer]', r); if (!d) return;
    lastOpener = opener || lastOpener;
    d.classList.add('is-open');
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    var ob = q('[data-lbmc-open-drawer]', r); if (ob) ob.setAttribute('aria-expanded', 'true');
    r.classList.add('has-overlay');
    lock(true);
  }
  function openSortSheet() {
    var r = root(); var s = r && q('[data-lbmc-sort]', r); if (!s) return;
    s.classList.add('is-open');
    var b = q('[data-lbmc-sort-btn]', r); if (b) b.setAttribute('aria-expanded', 'true');
    if (!DESK.matches) { r.classList.add('has-overlay'); lock(true); }
  }
  function closeAll(returnFocus) {
    var r = root(); if (!r) return;
    var d = q('[data-lbmc-drawer]', r);
    var wasOpen = d && d.classList.contains('is-open');
    var sortOpen = q('[data-lbmc-sort].is-open', r);
    if (d) { d.classList.remove('is-open'); d.removeAttribute('role'); d.removeAttribute('aria-modal'); }
    var ob = q('[data-lbmc-open-drawer]', r); if (ob) ob.setAttribute('aria-expanded', 'false');
    closeSort();
    if (DESK.matches) closeGroups();
    r.classList.remove('has-overlay');
    lock(false);
    if (returnFocus) {
      if (wasOpen) { var o = q('[data-lbmc-open-drawer]', r); if (o) o.focus(); }
      else if (sortOpen) { var sb = q('[data-lbmc-sort-btn]', r); if (sb) sb.focus(); }
    }
  }

  function snapshot() {
    var r = root(); var s = { expanded: [], drawer: false, sort: false, focus: null, scroll: 0 };
    if (!r) return s;
    var d = q('[data-lbmc-drawer]', r);
    s.drawer = !!(d && d.classList.contains('is-open'));
    s.sort = !!q('[data-lbmc-sort].is-open', r);
    s.expanded = qa('[data-lbmc-gbtn][aria-expanded="true"]', r).map(function (b) { return b.id; });
    var a = document.activeElement;
    if (a && r.contains(a) && a.id) s.focus = a.id;
    var g = q('[data-lbmc-groups]', r); if (g) s.scroll = g.scrollTop;
    return s;
  }
  function restore(s) {
    var r = root(); if (!r) return;
    if (s.drawer && !DESK.matches) {
      var d = q('[data-lbmc-drawer]', r);
      if (d) { d.classList.add('lbmc-noanim'); openDrawer(); requestAnimationFrame(function () { d.classList.remove('lbmc-noanim'); }); }
    }
    s.expanded.forEach(function (id) { var b = document.getElementById(id); if (b) b.setAttribute('aria-expanded', 'true'); });
    var g = q('[data-lbmc-groups]', r); if (g) g.scrollTop = s.scroll;
    if (s.focus) { var f = document.getElementById(s.focus); if (f && !f.disabled) f.focus({ preventScroll: true }); }
  }

  function buildUrl(form) {
    var p = new URLSearchParams();
    var def = form.getAttribute('data-default-sort');
    new FormData(form).forEach(function (v, k) {
      if (v === '' || v == null) return;
      if (k === 'sort_by' && v === def) return;
      p.append(k, v);
    });
    var qs = p.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  function load(url, push, scrollTop) {
    var r = root(); if (!r) { window.location.href = url; return; }
    var st = snapshot();
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    r.classList.add('is-loading');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(r.getAttribute('data-section-id')), ctrl ? { signal: ctrl.signal } : {})
      .then(function (res) { if (!res.ok) throw new Error('http'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.querySelector('[data-lbmc-root]');
        if (!nr) throw new Error('parse');
        r.innerHTML = nr.innerHTML;
        r.classList.remove('is-loading');
        if (push) history.pushState({ lbmc: true }, '', url);
        restore(st);
        var live = document.querySelector('[data-lbmc-live]');
        var cnt = q('.lbmc__count--desk', r);
        if (live && cnt) live.textContent = cnt.textContent.trim();
        if (scrollTop) {
          var top = r.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function apply() {
    var r = root(); var form = r && q('[data-lbmc-form]', r); if (!form) return;
    load(buildUrl(form), true, false);
  }

  document.addEventListener('click', function (e) {
    var r = root(); if (!r) return;
    var t = e.target;
    if (!r.contains(t)) { if (DESK.matches) { closeGroups(); closeSort(); } return; }

    var gb = t.closest('[data-lbmc-gbtn]');
    if (gb) {
      var open = gb.getAttribute('aria-expanded') === 'true';
      if (DESK.matches) { closeGroups(gb); closeSort(); }
      gb.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    var od = t.closest('[data-lbmc-open-drawer]');
    if (od) { closeSort(); openDrawer(od); var x = q('[data-lbmc-drawer] .lbmc__x', r); if (x) x.focus(); return; }

    var sb = t.closest('[data-lbmc-sort-btn]');
    if (sb) {
      var s = q('[data-lbmc-sort]', r);
      if (s.classList.contains('is-open')) { closeAll(false); }
      else { closeGroups(); openSortSheet(); var c = q('input[name="sort_by"]:checked', s) || q('input[name="sort_by"]', s); if (c && !DESK.matches) setTimeout(function () { c.focus(); }, 60); }
      return;
    }
    var cl = t.closest('[data-lbmc-close]');
    if (cl) { closeAll(true); return; }

    var ln = t.closest('a[data-lbmc-link]');
    if (ln) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      load(ln.getAttribute('href'), true, ln.hasAttribute('data-lbmc-scroll'));
      return;
    }
    if (DESK.matches && !t.closest('.lbmc__group') && !t.closest('[data-lbmc-sort]')) { closeGroups(); closeSort(); }
  });

  document.addEventListener('change', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var el = e.target;
    if (!el.closest('[data-lbmc-form]')) return;
    if (el.hasAttribute('data-lbmc-price')) return; /* prijs: toepassen via Enter of 'Appliquer' */
    if (el.name === 'sort_by') {
      if (DESK.matches) closeSort();
      else { closeAll(true); }
    }
    apply();
  });

  document.addEventListener('submit', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    if (!e.target.matches('[data-lbmc-form]')) return;
    e.preventDefault();
    apply();
  });

  document.addEventListener('keydown', function (e) {
    var r = root(); if (!r) return;
    if (e.key === 'Escape') {
      var openBtn = q('[data-lbmc-gbtn][aria-expanded="true"]', r);
      var d = q('[data-lbmc-drawer].is-open', r);
      var s = q('[data-lbmc-sort].is-open', r);
      if (DESK.matches && openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); return; }
      if (d || s) { closeAll(true); }
      return;
    }
    if (e.key === 'Tab') {
      var box = q('[data-lbmc-drawer].is-open', r) || (!DESK.matches && q('[data-lbmc-sort].is-open .lbmc__spanel', r));
      if (!box) return;
      var f = qa('a[href], button:not([disabled]), input:not([disabled])', box).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('popstate', function () {
    if (root()) load(window.location.href, false, false);
  });

  var onBp = function () { closeAll(false); };
  if (DESK.addEventListener) DESK.addEventListener('change', onBp); else if (DESK.addListener) DESK.addListener(onBp);
})();
